import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import EditDialog from "../LeftContent/EditDialog";
import FormHelperText from "@material-ui/core/FormHelperText";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import AddIcon from "@material-ui/icons/Add";
import Papa from "papaparse";
import { CircularProgress, TextField } from "@material-ui/core";
import moment from "moment";
import { isEmpty } from "lodash";
import { connect, useDispatch, useSelector } from "react-redux";
import { GetLatestRoadSurveyedFile, SetGraphCashData, UploadSurveyedData} from "../../../services/actions/RoadAction";
import { checkSurveyedYear, isNullOrEmpty } from "../../../shared/utils/objectExtensions";
import { SetWarning } from "../../../services/actions/SystemAction";
import { SURVEY_TYPE } from "../../../shared/utils/constant";
import i18n from "../../../localization/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: "250px",
  },
  radioGroup: {},
  formControl: {
    margin: theme.spacing(1),
    width: "30%",
  },
}));

const FieldsMappingDialog = ({
  handleClose,
  saveSuccess,
  open,
  files,
  setDataFile,
  UploadSurveyedData,
  userId,
  deteriorationCurveList
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [fileSelected, setFileSelected] = React.useState(0);
  const [processedData, setProcessedData] = React.useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [deteriorationCurveId, setDeteriorationCurveId] = useState(0);
  const {dpYears} = useSelector((state) => ({
    dpYears: state.road.dpYears
  }));

  const handleFileChange = (_event, newValue) => {
    setFileSelected(newValue);
  };

  const setFileType = (value) => {
    const currentData = [...processedData];
    currentData[fileSelected].fileType = value;
    setProcessedData(currentData);
  };

  // 追加
  const setLinegenerationType = (value) => {
    const currentData = [...processedData];
    currentData[fileSelected].lineGenerationType = value;
    setProcessedData(currentData)
  }

  const setSurveyYear = (value) => {
    const currentData = [...processedData];
    currentData[fileSelected].SurveyYear = value;
    setProcessedData(currentData);
  };

  const handleAddDP = () => {
    const currentData = [...processedData];
    const countDp = Object.keys(
      currentData[fileSelected].mappingFields.DP
    ).length;
    currentData[fileSelected].mappingFields.DP[`Y${countDp + 1}`] = "";
    setProcessedData(currentData);
  };

  const handleRemoeDP = (name) => {
    const currentData = [...processedData];
    delete currentData[fileSelected].mappingFields.DP[name];
    setProcessedData(currentData);
  };

  const handleFieldChange = (name, value) => {
    const currentData = [...processedData];
    currentData[fileSelected].mappingFields[name] = value;
    currentData[fileSelected].errors = null;
    setProcessedData(currentData);
  };

  const handleDPFieldChange = (name, value) => {
    const currentData = [...processedData];
    currentData[fileSelected].mappingFields.DP[name] = value;
    setProcessedData(currentData);
  };

  const handleDeteriorationCurveData = (value) => {
    const currentData = [...processedData];
    currentData[fileSelected].DeteriorationCurveData = value;
    setDeteriorationCurveId(value);
    setProcessedData(currentData);
  };

  const handleSubmitData = async () => {
    // Validate data
    const currentData = [...processedData];
    let hasError = false;

    for (let i = 0; i < currentData.length; i++) {
      let item = currentData[i];
      var errors = {};
      if (!item.SurveyYear) {
        errors["SurveyYear"] = "Survey Year is required";
        hasError = true;
      }

      Object.keys(item.mappingFields).forEach((key) => {
        // RoadSurfaceのみ任意
        if (key === "RoadSurface") return;
        // 基本的にすべて必須フィールドになる、現状その仕様になっている

        // ["Latitude",
        // "Longitude",
        // "Distress",
        // "RoadName",] が元々必須フィールドだった
        if (!item.mappingFields[key]) {
          errors[key] = `${key} is required`;
          hasError = true;
        }
      });

      // Actual年 過年度チェック
      const year = item.SurveyYear;
      if (!await checkSurveyedYear(userId, year)) {
        hasError = true;
        errors["SurveyYear"] = `Survey Year(${year}) can't update!`;
      }

      // Deterioration Curveの選択値チェック
      if (!item.DeteriorationCurveData) {
        errors["DeteriorationCurveData"] = "Deterioration Curve is required";
        hasError = true;
      }

      item.errors = errors;
    }

    const data = await dispatch(GetLatestRoadSurveyedFile(userId));

    if (
      !hasError &&
      data &&
      data[0] &&
      surveyType !== SURVEY_TYPE[data[0].type].value
    ) {
      dispatch(
        SetWarning(
          i18n.t("deterioration_curve_upload_error_message")
        )
      );
      hasError = true;
    }

    if (!hasError) {
      var submitObj = [];
      // for (const item of currentData) {
      currentData.forEach((item) => {
        submitObj.push({
          file: item.file,
          surveyType: item.fileType,
          surveyYear: item.SurveyYear,
          userId: userId,
          maxDpYear:
            item.fileType === "2" && item.mappingFields["DP"]
              ? Number(item.SurveyYear) +
              Object.keys(item.mappingFields["DP"]).length
              : null,
          predictedYears:
            item.fileType === "2"
              ? Object.keys(item.mappingFields["DP"]).map(
                (_k, idx) => Number(item.SurveyYear) + idx + 1
              )
              : null,
          parsedData: item.parsedData.map((x) => {
            return {
              Kp: item.mappingFields["Kp"]
                ? x[item.mappingFields["Kp"]]
                : "",
              SourceVideo: item.mappingFields["SPM-IRI"]
                ? x[item.mappingFields["SPM-IRI"]]
                : "",
              Latitude: item.mappingFields["Latitude"]
                ? x[item.mappingFields["Latitude"]]
                : "",
              Longitude: item.mappingFields["Longitude"]
                ? x[item.mappingFields["Longitude"]]
                : "",
              PicPathDetected: item.mappingFields["PicPath_Detected"]
                ? x[item.mappingFields["PicPath_Detected"]]
                : "",
              PicPathOriginal: item.mappingFields["PicPath_Original"]
                ? x[item.mappingFields["PicPath_Original"]]
                : "",
              VideoDate: item.mappingFields["VideoDate"]
                ? x[item.mappingFields["VideoDate"]]
                : "",
              DefectTime: item.mappingFields["DefectTime"]
                ? x[item.mappingFields["DefectTime"]]
                : "",
              Distress: item.mappingFields["Distress"]
                ? x[item.mappingFields["Distress"]]
                : "",
              RoadName: item.mappingFields["RoadName"]
                ? x[item.mappingFields["RoadName"]]
                : "",
              RoadSurface: item.mappingFields["RoadSurface"]
                ? x[item.mappingFields["RoadSurface"]]
                : "",
              DP: item.mappingFields["DP"]
                ? Object.keys(item.mappingFields["DP"]).map(
                  (y) => x[item.mappingFields["DP"][y]]
                )
                : null,
            };
          }),
          lineGenerationType: item.lineGenerationType,
          deteriorationCurveId:item.DeteriorationCurveData,
          fieldSurface: item.mappingFields.RoadSurface,
          kpColumnName: item.mappingFields.Kp
        });
      });

      hasError = false;
      for (const file of submitObj) {
        for (const item of file.parsedData) {
          const resultUnit = validateItem(item, file.surveyType);
          if (!resultUnit.ok) {
            hasError = true;
            // メッセージ表示
            dispatch(SetWarning(resultUnit.message));
            break;
          }
        }
        if (hasError) break;
        const result = validateItems(file.parsedData);
        if (!result.ok) {
          // メッセージ表示
          dispatch(SetWarning(result.message));
          hasError = true;
          break;
        }
      }
      if (hasError) {
        setProcessedData(currentData);
      } else {
        UploadSurveyedData(submitObj, () => {
          saveSuccess();
          try{
            dispatch(SetGraphCashData({
              [userId] : null
            }));
          }catch(e){
            console.error(e);
          }
        });
      }
    } else {
      setProcessedData(currentData);
    }
  };

  useEffect(() => {
    if (files) {
      var result = [];

      Promise.all(
        files.map(
          (file) =>
            new Promise((resolve, reject) =>
              Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: resolve,
                error: reject,
              })
            )
        )
      ).then((results) => {
        const arrayRemoveIdx = [];
        results.forEach((parseData, idx) => {
          if (parseData.data.length === 0) {
            arrayRemoveIdx.push(idx);
            return;
          }

          let headers = Object.keys(parseData.data[0]);
          let hasDP = false;
          let currentObj = {
            Kp: "",
            "SPM-IRI": "",
            Latitude: "",
            Longitude: "",
            PicPath_Detected: "",
            PicPath_Original: "",
            VideoDate: "",
            DefectTime: "",
            Distress: "",
            RoadName: "",
            RoadSurface: "",
            DP: {
              Y1: "",
              Y2: "",
              Y3: "",
            },
          };
          Object.keys(currentObj).map((k) => {
            if (k === "DP") {
              Object.keys(currentObj.DP).map((dpKey) => {
                const dpHeaderName = headers.find(
                  (h) => h.toLowerCase() === `DP-${dpKey}`.toLowerCase()
                );
                if (dpHeaderName) {
                  hasDP = true;
                }
                currentObj.DP[dpKey] = dpHeaderName || "";
              });
            } else {
              const headerName = headers.find(
                (h) => h.toLowerCase() === k.toLowerCase()
              );
              currentObj[k] = headerName || "";
            }
          });

          var surveyYear = parseData.data[0].VideoDate
            ? moment(parseData.data[0].VideoDate).year()
            : moment().year(); // 1行目のVideoDate -> 現在の年の優先順位で初期設定
          if (isNaN(surveyYear)) {
            surveyYear = moment(
              parseData.data[0].VideoDate,
              "DD/MM/YYYY"
            ).year();

            if (!isNaN(surveyYear)) {
              parseData.data = parseData.data.map((x) => {
                var test = moment(x.VideoDate).year();
                if (isNaN(test)) {
                  x.VideoDate = moment(x.VideoDate, "DD/MM/YYYY").format(
                    "MM/DD/YYYY"
                  );
                }
                return x;
              });
            }
          }

          result.push({
            file: files[idx],
            SurveyYear: surveyYear,
            parsedData: parseData.data,
            fileType: hasDP ? "2" : "0",
            fieldList: headers,
            mappingFields: currentObj,
            lineGenerationType: "0", // 追加(ライン生成方式)
            DeteriorationCurveData:deteriorationCurveId
          });
        });

        // CSV内に0行のファイルがあった場合、警告表示、およびリストから削除(一瞬リストに出るのは仕様)
        if (arrayRemoveIdx.length > 0) {
          for (let i = arrayRemoveIdx.length - 1; i >= 0; i--) {
            files.splice(arrayRemoveIdx[i], 1);
          }
          const newFiles = [];
          for (const file of files) {
            newFiles.push(file);
          }
          setDataFile(newFiles); // リスト更新
          dispatch(SetWarning(`These files contains no-data. And no-data file remove.`));
        }

        setProcessedData(result);
      }).catch((error) => {
        console.log("Something went wrong: ", error)
      });
    }
  }, [files]);

  const [surveyType, setSurveyType] = useState("0");

  useEffect(() => {
    if (deteriorationCurveList && deteriorationCurveList.length > 0) {
      setDeteriorationCurveId(deteriorationCurveList[0].id);
    } else {
      setDeteriorationCurveId(null);
    }
  }, [deteriorationCurveList]);

  return (
    <Dialog fullWidth maxWidth="lg" open={open} disableBackdropClick={true}>
      <DialogTitle style={{ backgroundColor: "#E28020", color: "white" }}>
        Fields mapping
      </DialogTitle>
      <DialogContent
        dividers
        style={{ textAlign: processedData?.length ? "" : "center" }}
      >
        {processedData?.length ? (
          <div className={classes.root}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={fileSelected}
              onChange={handleFileChange}
              className={classes.tabs}
            >
              {files ? (
                files.map((x, idx) => {
                  const hasError =
                    processedData[idx]?.errors &&
                      !isEmpty(processedData[idx]?.errors)
                      ? true
                      : false;
                  return (
                    <Tab
                      key={idx}
                      label={x.name}
                      {...a11yProps(idx)}
                      style={{
                        textTransform: "none",
                        color: hasError ? "red" : "inherit",
                      }}
                    />
                  );
                })
              ) : (
                <></>
              )}
            </Tabs>
            {processedData?.length ? (
              processedData.map((item, idx) => {
                return (
                  <TabPanel
                    key={idx}
                    value={fileSelected}
                    index={idx}
                    className={classes.radioGroup}
                  >
                    {/* 追加 */}
                    <RadioGroup
                      row
                      aria-label="position"
                      name="position"
                      defaultValue={"0"}
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        marginBottom: "20px"
                      }}
                      value={item.lineGenerationType}
                      onChange={(e, newValue) => {
                        setLinegenerationType(newValue);
                      }}
                    >
                      <FormLabel>Line Generation Type</FormLabel>
                      <FormControlLabel
                        value={"0"}
                        control={<Radio color="primary" />}
                        label="5 Points Moving Average"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value={"1"}
                        control={<Radio color="primary" />}
                        label="Summary Distress Color"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                    {/* 追加 */}
                    <RadioGroup
                      row
                      aria-label="position"
                      name="position"
                      defaultValue={"0"}
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                      value={item.fileType}
                      onChange={(e, newValue) => {
                        setFileType(newValue);
                      }}
                    >
                      <FormControlLabel
                        value={SURVEY_TYPE.SPM_PASER.value}
                        control={<Radio color="primary" />}
                        label={SURVEY_TYPE.SPM_PASER.label}
                        labelPlacement="end"
                        onChange={(e) => {
                          setSurveyType(e.target.value);
                        }}
                      />
                      <FormControlLabel
                        value={SURVEY_TYPE.SPM_PCI.value}
                        control={<Radio color="primary" />}
                        label={SURVEY_TYPE.SPM_PCI.label}
                        labelPlacement="end"
                        onChange={(e) => {
                          setSurveyType(e.target.value);
                        }}
                      />
                      <FormControlLabel
                        value={SURVEY_TYPE.SPM_PCI_DP.value}
                        control={<Radio color="primary" />}
                        label={SURVEY_TYPE.SPM_PCI_DP.label}
                        labelPlacement="end"
                        onChange={(e) => {
                          setSurveyType(e.target.value);
                        }}
                      />
                      <TextField
                        label="Survey Year"
                        style={{ marginBottom: "20px" }}
                        value={item.SurveyYear}
                        onChange={(e) => setSurveyYear(e.target.value)}
                        error={item.errors?.SurveyYear ? true : false}
                        helperText={item.errors?.SurveyYear}
                      ></TextField>
                    </RadioGroup>
                    <div className="fields-mapping-container">
                      {Object.keys(item.mappingFields).map((key, idx) => {
                        const error = item.errors ? item.errors[key] : "";
                        return key !== "DP" ? (
                          <FormControl
                            key={idx}
                            className={classes.formControl}
                            error={error ? true : false}
                          >
                            <InputLabel
                              shrink={true}
                              className="header-selector"
                            >
                              {key}
                            </InputLabel>
                            <Select
                              onChange={(e) => {
                                handleFieldChange(key, e.target.value);
                              }}
                              value={item.mappingFields[key]}
                            >
                              {item.fieldList.map((x, idx) => (
                                <MenuItem key={idx} value={x}>
                                  {x}
                                </MenuItem>
                              ))}
                            </Select>
                            {error ? (
                              <FormHelperText>{error}</FormHelperText>
                            ) : (
                              <></>
                            )}
                          </FormControl>
                        ) : (
                          <React.Fragment key={idx}></React.Fragment>
                        );
                      })}
                      {item.fileType === "2" ? (
                        <><div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          <DPInput
                            classes={classes}
                            list={item.mappingFields.DP
                              ? Object.keys(item.mappingFields.DP).map(
                                (k) => ({
                                  id: k,
                                  value: item.mappingFields.DP[k],
                                })
                              )
                              : []}
                            mappingFields={item.mappingFields}
                            fieldList={item.fieldList}
                            handleFieldChange={handleDPFieldChange}
                            handleAdd={handleAddDP}
                            handleRemove={handleRemoeDP} />
                        </div><FormControl
                          error={item.errors?.DeteriorationCurveData ? true : false}
                          style={{
                            marginLeft: "10px",
                            display: 'block',
                            flexBasis: "100%"
                          }}
                        >
                            <InputLabel shrink={true}
                              className="header-selector"
                            >
                              {i18n.t("deterioration_curve")}
                            </InputLabel>
                            <Select
                              onChange={(e) => {
                                handleDeteriorationCurveData(e.target.value);
                              } }
                              value={deteriorationCurveId}
                              style={{
                                width: "200px",
                              }}
                            >
                              {deteriorationCurveList.map((deteriorationCurve, idx) => {
                                return (
                                  <MenuItem key={idx} value={deteriorationCurve.id}>
                                    {deteriorationCurve.title}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            {item.errors?.DeteriorationCurveData ? (
                              <FormHelperText>{item.errors?.DeteriorationCurveData}</FormHelperText>
                            ) : (
                              <></>
                            )}
                            <Button
                              color="primary"
                              variant="contained"
                              className="deterioration-curve-edit-btn"
                              onClick={() => {
                                setOpenEditDialog(true);
                              } }
                            >
                              {i18n.t("edit")}
                            </Button>
                          </FormControl></>
                      ) : (
                        <></>
                      )}

                    </div>

                  </TabPanel>
                );
              })
            ) : (
              <></>
            )}
          </div>
        ) : (
          <CircularProgress color="primary" />
        )}
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="contained" onClick={handleSubmitData}>
          Save
        </Button>
        <Button onClick={handleClose} color="default" variant="outlined">
          Close
        </Button>
      </DialogActions>
      <EditDialog
        open={openEditDialog}
        handleClose={() => setOpenEditDialog(false)}
      />
    </Dialog>
    
  );
};

const DPInput = ({
  classes,
  list,
  mappingFields,
  fieldList,
  handleFieldChange,
  handleAdd,
  handleRemove,
}) => {
  return list && mappingFields.DP ? (
    <>
      {list.map((x, idx) => {
        return (
          <div
            key={idx}
            className={classes.formControl}
            style={{ display: "flex" }}
          >
            <FormControl key={idx} style={{ width: "100%" }}>
              <InputLabel shrink={true} className="header-selector">
                DP-{x.id}
              </InputLabel>
              <Select
                onChange={(e) => {
                  handleFieldChange(x.id, e.target.value);
                }}
                value={x.value}
              >
                {fieldList.map((x, idx) => (
                  <MenuItem key={idx} value={x}>
                    {x}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button onClick={() => handleRemove(x.id)}>
              <CloseIcon />
            </Button>
          </div>
        );
      })}
      <Button variant="text" startIcon={<AddIcon />} onClick={handleAdd}>
        DP-Y
      </Button>
    </>
  ) : (
    <></>
  );
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

/**
 * CSVの内容について、個別行のバリデートを行う
 * @param {*} aItem 読込んだ行データ
 * @param {string} aSurveyType 取込方法("0": SPM-PASER "1":SPM-PCI "2":SPM-PCI+DP)
 * @returns {object} 判定結果 ok: (boolean)チェックOK message: (string)チェックNGの詳細
 */
const validateItem = (aItem, aSurveyType) => {
  const result = {
    ok: true,
    message: ""
  };
  // KP: 整数値かどうか
  const numKp = Number(aItem.Kp);
  if (isNullOrEmpty(aItem.Kp) || !Number.isInteger(numKp)) {
    result.ok = false;
    result.message = `KP values contains empty or not number.`;
  }
  // Distress: 整数値かどうか
  const numDistress = Number(aItem.Distress);
  if (isNullOrEmpty(aItem.Distress) || Number.isNaN(numDistress)) {
    result.ok = false;
    result.message = `Distress values contains empty or not number`;
    result.message += (Number.isNaN(numDistress)) ? `[${aItem.Distress}]` : "";
  }

  // DP: 整数値かどうか(SPM-PCI+DP)
  if (aSurveyType === SURVEY_TYPE.SPM_PCI_DP.value) {
    for (var dpValue of aItem.DP) {
      const numDP = Number(dpValue);
      if (isNullOrEmpty(dpValue) || Number.isNaN(numDP)) {
          result.ok = false;
          result.message = `[Survey Type: SPM-PCI + DP]DP-Y~ values contains empty or not number`;
          result.message += (Number.isNaN(numDP)) ? `[${dpValue}]` : "";
          break;
      }
    }
  }

  return result;
}

/**
 * CSVの内容について、ファイル全体のバリデートを行う
 * @param {*} aData
 * @returns
 */
const validateItems = (aData) => {
  const result = {
    ok: true,
    message: ""
  };

  const kps = aData.map(d => d.Kp);
  const kpDistinct = new Set(kps);

  // KPにおいて、ファイル内に重複がないか
  if (kps.length !== kpDistinct.size) {
    result.ok = false;
    result.message = `This file contains same KP value.`
  }
  return result;
}

export default connect(
  (state) => ({
    deteriorationCurveList: state.road.deteriorationCurveList,
  }),
  (dispatch) => ({
    UploadSurveyedData: (data, callback) =>
      dispatch(UploadSurveyedData(data, callback)),
  })
)(FieldsMappingDialog);
